import React from 'react';
import TextInput from './textInput';

export default props => {
  const {
    icon,
    placeholder,
    type,
    input,
    label,
    labelExtra,
    meta: { touched, error },
  } = props;
  return (
    <div>
      {label && (
        <label>
          {label} {labelExtra && <span className="label-subtitle">{labelExtra}</span>}
        </label>
      )}
      <TextInput
        icon={icon}
        id={input.name}
        placeholder={placeholder}
        specialClass={touched && !error ? 'has-success' : ''}
        type={type}
        validationErrors={touched && !!error ? [error] : []}
        {...input}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/inputs/validatedTextInput.js